/** Process-wide RSS story window rotation (must not live in an SFC — Vite can instantiate SFC modules more than once). */

const storyWindowIndexByEntryId = new Map<string, number>()
const lastWindowAdvanceMsByEntryId = new Map<string, number>()

export function rssStoryWindowIndexFor(entryId: string): number {
  return storyWindowIndexByEntryId.get(entryId) ?? 0
}

export function setRssStoryWindowIndex(entryId: string, index: number): void {
  storyWindowIndexByEntryId.set(entryId, index)
}

export function rssStoryWindowLastAdvanceMs(entryId: string): number | undefined {
  return lastWindowAdvanceMsByEntryId.get(entryId)
}

export function setRssStoryWindowLastAdvanceMs(entryId: string, ms: number): void {
  lastWindowAdvanceMsByEntryId.set(entryId, ms)
}

export function resetRssStoryWindowSession(entryId: string): void {
  storyWindowIndexByEntryId.delete(entryId)
  lastWindowAdvanceMsByEntryId.delete(entryId)
}
